import { TextField, useTheme } from '@mui/material';
import { observer } from 'mobx-react';
import FormFieldBase from './FormFieldBase';

function FormNumberField ({
  label = undefined,
  placeholder = undefined,
  field,
  updateValue = (event, value) => {field.updateValue(value)},
  width = '25%',
  disabled = false,
}) {
  const theme = useTheme();
  const style = styles(theme, width);

  return (
    <FormFieldBase>
      <TextField
        label={label}
        placeholder={placeholder}
        InputLabelProps={{ shrink: field.value !== '' && field.value !== undefined ? true : undefined }}
        inputProps={{ type: 'number' , min: 1}}
        disabled={disabled}
        style={style.fieldContainer}
        sx={{'& .MuiInputLabel-root, & .MuiInputLabel-shrink, & .MuiOutlinedInput-root, & .MuiInputBase-input': {
          fontSize: '.8rem',
        },
        }}
        value={field.value}
        onChange={(event) => {
          let value = event.target.value;
          if (value === "0") {
            value = "1";
          }
          if (value && value < 0) {
            value = Math.abs(event.target.value).toString();
          }
          field.updateValue(value);
        }}
        onBlur={(event) => {
            updateValue(event, field.value);
        }}
      />
    </FormFieldBase>
  );
}

const styles = (theme, width) => ({
  fieldContainer: {
    backgroundColor: theme.brand.field,
    justifyContent: 'center',
    borderRadius: '0.5rem',
    width: width,
  },
});

export default observer(FormNumberField);